import React, { Fragment } from "react";
import YesIcon from "@mui/icons-material/Check";
import NoIcon from "@mui/icons-material/Block";
import { green, red } from "@mui/material/colors";
import { Box } from "@mui/material";

const YesNoCard = ({ value, showNoIcon = true }) => {
  return (
    <Box>
      {value ? (
        <Fragment>
          <YesIcon
            aria-label="yes"
            fontSize="large"
            style={{ color: green[500] }}
          />
        </Fragment>
      ) : showNoIcon ? (
        <Fragment>
          <NoIcon
            aria-label="no"
            fontSize="large"
            style={{ color: red[500] }}
          />
        </Fragment>
      ) : (
        <Fragment />
      )}
    </Box>
  );
};

export default YesNoCard;
